// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZJjq","importantInfo":"styles_importantInfo__1b9Kh"};